// Numbers inside names compare as numbers. The backend lists by name, as text, so a set not padded to a
// fixed width came back as 1, 10, 100, 11, 2 — and "next" from level 9 would have been level 90.
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
// The name a list row shows: the backend stores the FILE name (LevelFileName appends ".json").
export function levelDisplayName(listedName) {
    return listedName.replace(/\.json$/i, "");
}
// The key a template's own name is stored under, mirroring ContentController.LevelFileName: trimmed,
// path separators made safe, ".json" dropped, compared case-insensitively (NameLower). A list row and
// the open template are the same level exactly when their keys match — the row says "0075.json", the
// template says "0075".
export function levelKey(name) {
    const trimmed = (name ?? "").trim();
    const base = trimmed === "" ? "untitled" : trimmed.replace(/[\\/\0]/g, "_");
    return levelDisplayName(base).toLowerCase();
}
export function sortLevelsNaturally(levels) {
    return [...levels].sort((a, b) => collator.compare(levelDisplayName(a.name), levelDisplayName(b.name)));
}
export function containsLevel(levels, currentName) {
    const key = levelKey(currentName);
    return levels.some((l) => levelKey(l.name) === key);
}
// The level `step` places from the template named `currentName` (−1 = previous, +1 = next), or null when
// that level is not in the list (never saved here, or a rename not yet saved) or the step runs off either
// end.
export function neighbourLevel(levels, currentName, step) {
    const key = levelKey(currentName);
    const index = levels.findIndex((l) => levelKey(l.name) === key);
    if (index < 0) {
        return null;
    }
    return levels[index + step] ?? null;
}
